import "./Offices.css"

export default function Offices() {
  const officesData = [
    {
      id: 1,
      city: "LONDON",
      country: "UNITED KINGDOM",
      address: "NORTHSIDE HOUSE, MOUNT PLEASANT, COCKFOSTERS, EN4 9EB",
      iconPath: "/icons/london.webp", // Place your icon file in public/icons/
    },
    {
      id: 2,
      city: "LISBON",
      country: "PORTUGAL",
      address: "AV. ANT. AUG. DE AGUIAR 108, 3º 1050-019 LISBON",
      iconPath: "/icons/lisbon.webp", // Replace with your actual file names
    },
    {
      id: 3,
      city: "COIMBRA",
      country: "PORTUGAL",
      address: "R. PEDRO NUNES, EDIFÍCIO C 3030-199 COIMBRA",
      iconPath: "/icons/coimbra.webp", // Replace with your actual file names
    },
  ]

  return (
    <section className="offices-section">
      <div className="container">
        <div className="offices-header">
          <h2 className="our-text">OUR</h2>
          <h3 className="offices-text">OFFICES</h3>
        </div>

        <div className="offices-grid">
          {officesData.map((office, index) => (
            <div key={office.id} className="office-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <img
                src={office.iconPath || "/placeholder.svg"}
                alt={`${office.city} office icon`}
                className="office-icon"
              />
              <div className="office-city">{office.city}</div>
              <div className="office-country">{office.country}</div>
              <div className="office-address">{office.address}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
